import type { WageringConfiguration } from '../../../../@types/api';
import type { WageringConfigurationFormData } from '../../../../schema';
import {
  createGameWeightingContributionRows,
  toCompleteGameWeightingContributionsPayload,
  toGameWeightingContributionRows,
} from './WageringFields';

export const WAGERING_CONFIGURATION_DEFAULT_VALUES: WageringConfigurationFormData = {
  minSelections: null,
  minOddsPerSelection: null,
  maxBetLimit: null,
  gameWeightingContributions: createGameWeightingContributionRows(null),
};

export const getWageringConfigurationFormData = (
  configuration: WageringConfiguration | null | undefined
): WageringConfigurationFormData => {
  if (!configuration) return WAGERING_CONFIGURATION_DEFAULT_VALUES;

  return {
    minSelections: configuration.sportsbook.minSelections ?? null,
    minOddsPerSelection: configuration.sportsbook.minOddsPerSelection ?? null,
    maxBetLimit: configuration.casino.maxBetLimit ?? null,
    gameWeightingContributions: toGameWeightingContributionRows(configuration.casino.gameWeightingContributions),
  };
};

export const buildWageringConfigurationPayload = (data: WageringConfigurationFormData): WageringConfiguration => ({
  sportsbook: {
    minSelections: data.minSelections,
    minOddsPerSelection: data.minOddsPerSelection,
  },
  casino: {
    maxBetLimit: data.maxBetLimit,
    gameWeightingContributions: toCompleteGameWeightingContributionsPayload(data.gameWeightingContributions),
  },
});
